// extracted by mini-css-extract-plugin
module.exports = {"app-section-container":"style_app-section-container__btd1P"};